export default __webpack_public_path__ + "static/media/id-ok.0fde9af0.jpg";